import { render, staticRenderFns } from "./ViewOpportunity.vue?vue&type=template&id=6af576e5&"
import script from "./ViewOpportunity.vue?vue&type=script&lang=js&"
export * from "./ViewOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af576e5')) {
      api.createRecord('6af576e5', component.options)
    } else {
      api.reload('6af576e5', component.options)
    }
    module.hot.accept("./ViewOpportunity.vue?vue&type=template&id=6af576e5&", function () {
      api.rerender('6af576e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/opportunity/ViewOpportunity.vue"
export default component.exports